export enum ReportValue {
    No = 0,
    Optional = 1,
    Mandatory = 2,
}
